import { TablerIcon } from "@tabler/icons";
import { useTheme } from "styled-components";

import { ColumnContainer, Wrapper } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";
import { InputLabel, RawInput } from "@sso/ui/RawInput";
import { Typography } from "@sso/ui/Typography";

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label?: string;
  error?: boolean;
  disabled?: boolean;
  EndIcon?: TablerIcon;
  endIconTitle?: string;
  borderShadow?: boolean;
  onClickEndIcon?: () => void;
  errorText?: string | null;
  noMargin?: boolean;
}

export const TextInput = ({
  id,
  label,
  error,
  disabled,
  errorText,
  EndIcon,
  borderShadow,
  endIconTitle,
  placeholder,
  noMargin,
  onClickEndIcon,
  ...rest
}: TextInputProps) => {
  const theme = useTheme();
  const getColor = (icon: boolean) => {
    if (disabled) {
      return theme.colors.action.disabled;
    } else if (error) {
      return theme.colors.error.main;
    } else {
      return icon ? theme.colors.grey[500] : theme.colors.grey[700];
    }
  };
  return (
    <ColumnContainer
      position="relative"
      margin={noMargin ? "0" : "0 0 1rem 0"}
      padding="0 0.2rem"
      align="flex-start"
      justify="flex-start"
      width="100%"
    >
      <RawInput
        id={id}
        error={error}
        disabled={disabled}
        borderShadow={borderShadow}
        endIcon={!!EndIcon}
        placeholder={label ? " " : placeholder}
        {...rest}
      />
      {label && <InputLabel htmlFor={id}>{label}</InputLabel>}
      {error && (
        <Typography color={theme.colors.error.main} size="0.8rem" textAlign="left" margin="0.2rem">
          {errorText}
        </Typography>
      )}
      {EndIcon && (
        <Wrapper position="absolute" right="1rem" top="0.65rem" title={endIconTitle} cursor="pointer">
          <IconButton padding="0" margin="0">
            <EndIcon color={getColor(true)} onClick={onClickEndIcon} />
          </IconButton>
        </Wrapper>
      )}
    </ColumnContainer>
  );
};
